import React, { useEffect, useState } from "react";
import { DEFAULT_LISTING_PLACEHOLDER, listingCoverImage } from "../lib/fileUrl";

const DEFAULT_FALLBACK = DEFAULT_LISTING_PLACEHOLDER;

/**
 * Listing photo with graceful fallback when /api/files/{id} is missing in storage.
 */
export default function ListingImage({
  images,
  fallback = DEFAULT_FALLBACK,
  alt = "",
  className = "",
  ...props
}) {
  const primary = listingCoverImage(images, fallback || DEFAULT_FALLBACK);
  const [src, setSrc] = useState(primary);

  useEffect(() => {
    setSrc(listingCoverImage(images, fallback || DEFAULT_FALLBACK));
  }, [images, fallback]);

  const onError = () => {
    const fb = fallback || DEFAULT_FALLBACK;
    if (fb && src !== fb) setSrc(fb);
  };

  if (!src) return null;

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={onError}
      loading={props.loading ?? "lazy"}
      {...props}
    />
  );
}
